import { useGetMemberChangeLogsQuery } from '@bo-services/members/membersApi';

export interface MemberChangeLogsProps {
  memberId: string;
}

export const useMemberChangeLogs = ({ memberId }: MemberChangeLogsProps) => {
  const {
    data: changeLogs,
    isError,
    isFetching
  } = useGetMemberChangeLogsQuery(
    {
      id: memberId
    },
    {
      skip: !memberId
    }
  );

  return {
    changeLogs,
    isError,
    isFetching
  };
};
